import {
  DataGrid,
  GridColDef,
  GridRowsProp,
  GridRowParams,
} from "@mui/x-data-grid";
import classes from "./DataGrid.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { User } from "../../api/authApi";

interface DataGridCompProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  onRowClick?: (params: GridRowParams) => void;
  getRowId?: (row: any) => string | number;
  centerFields?: string[];
}

const DataGridComp: React.FC<DataGridCompProps> = ({
  rows,
  columns,
  onRowClick,
  getRowId,
  centerFields,
}) => {

  const user = useSelector(
    (state: RootState) => state.auth.user as User | null
  );

  // Generate selectors for cells and header containers
  const centerCellSelector =
    centerFields
      ?.map((field) => `& .MuiDataGrid-cell[data-field='${field}']`)
      .join(", ") ?? "";

  const centerHeaderContainerSelector =
    centerFields
      ?.map(
        (field) =>
          `& .MuiDataGrid-columnHeader[data-field='${field}'] .MuiDataGrid-columnHeaderTitleContainer`
      )
      .join(", ") ?? "";

  return (
    <div className={classes.datagrid} style={{ height: 450, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId ?? ((row) => row.id ?? row.job_id)}
        onRowClick={user?.can_write ? onRowClick : undefined}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
        }}
        pageSizeOptions={[5, 10, 20]}
        disableRowSelectionOnClick
        sx={{
          borderRadius: "10px",
          overflow: "hidden",
          fontFamily: "Poppins",
          "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle, & .MuiTablePagination-root, & .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-actions":
          {
            fontFamily: "Poppins",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#002060 !important",
            color: "white !important",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#002060 !important",
            color: "white !important",
          },
          "& .MuiDataGrid-sortIcon, & .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-menuIcon, & .MuiDataGrid-menuIconButton":
          {
            color: "white !important",
          },
          "& .MuiDataGrid-columnSeparator": {
            color: "white !important",
            opacity: 0.5,
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          // Center row cells
          [centerCellSelector]: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          // Center header content
          [centerHeaderContainerSelector]: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      />
    </div>
  );
};

export default DataGridComp;
